
import * as XLSX from 'xlsx';

/**
 * Reads an Excel file and returns a workbook object with UTF-8 encoding support
 */
export const readExcelFile = async (file: File): Promise<XLSX.WorkBook> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      try {
        // Set UTF8 encoding explicitly to ensure proper character handling
        const workbook = XLSX.read(data, { type: 'array', cellText: true, codepage: 65001 });
        console.log('Workbook loaded with UTF-8 support');
        resolve(workbook);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};
